import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import ActiveCampaignEmbed from '../ActiveCampaignEmbed';
import FormErrorBoundary from '../FormErrorBoundary';

/**
 * Final call to action section for Let's Collaborate page with embedded form
 *
 * @returns {JSX.Element} Call to action component with form
 */
function LetsCollaborateCallToAction() {
  const [formHTML, setFormHTML] = useState('');

  useEffect(() => {
    // Fetch the form HTML from the text file in the public folder
    fetch('/forms/lets-collaborate-form.txt')
      .then((response) => response.text())
      .then((html) => setFormHTML(html))
      .catch((error) => console.error('Error loading form:', error));
  }, []);
  return (
    <Box
      sx={{
        mt: 8,
        p: 6,
        backgroundColor: 'var(--color-card)',
        borderRadius: '12px',
        textAlign: 'center',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
        position: 'relative',
        border: '1px solid var(--color-border)',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: -1,
          left: -1,
          width: '80px',
          height: '80px',
          borderTop: '4px solid var(--color-primary)',
          borderLeft: '4px solid var(--color-primary)',
          borderRadius: 0,
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: -1,
          right: -1,
          width: '80px',
          height: '80px',
          borderBottom: '4px solid var(--color-primary)',
          borderRight: '4px solid var(--color-primary)',
          borderRadius: 0,
        },
      }}
    >
      <Typography
        variant="h3"
        sx={{ fontWeight: 600, mb: 2, color: 'var(--color-heading)' }}
      >
        Ready to Get Started?
      </Typography>
      <Typography
        sx={{
          color: 'var(--color-text-muted)',
          mb: 4,
          fontSize: '1.125rem',
          maxWidth: '600px',
          mx: 'auto',
        }}
      >
        Choose your collaboration path and join us in transforming the future of
        technology consulting.
      </Typography>

      {/* ActiveCampaign Form Embed */}
      <Box sx={{ maxWidth: '600px', mx: 'auto', mt: 3 }}>
        <FormErrorBoundary fallbackMessage="Unable to load contact form">
          {formHTML && <ActiveCampaignEmbed htmlContent={formHTML} />}

          {/* Loading state while form loads */}
          {!formHTML && (
            <Typography
              variant="body2"
              sx={{ color: 'var(--color-text-muted)' }}
            >
              Loading contact form...
            </Typography>
          )}
        </FormErrorBoundary>
      </Box>
    </Box>
  );
}

export default LetsCollaborateCallToAction;
